
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 8.938A2.065 2.065 0 008.937 11c0 1.137.926 2.063 2.063 2.063A2.065 2.065 0 0013.063 11 2.065 2.065 0 0011 8.937zM4.125 8.938A2.065 2.065 0 002.062 11c0 1.137.926 2.063 2.063 2.063A2.065 2.065 0 006.188 11a2.065 2.065 0 00-2.063-2.063zM17.875 8.938A2.065 2.065 0 0015.812 11c0 1.137.926 2.063 2.063 2.063A2.065 2.065 0 0019.938 11a2.065 2.065 0 00-2.063-2.063z","fill":"#fff"}})])
          )
        }
      }
    